angular.module('b2bLoginApp.controllers').controller('InfobarController',
    ["$scope", function($scope) {
        $scope.isStatus = function(clientStatus) {
            if ($scope.company === null) { return false; }
            var map = {
                2:  'active',    // Client
                3:  'cancelled', // Not active
                5:  'cancelled', // Removed
                6:  'paused',    // Not paid
                7:  'paused',    // Holiday
                8:  'paused',    // Break
                9:  'paused',    // Waiting on forms client
                10: 'cancelled', // Collecting agency
                11: 'cancelled', // Bankrupt
                12: 'paused',    // Wait for confirmation free trial
                13: 'paused',    // Queue list free trial
                14: 'expired',   // Block free trial
                16: 'active',    // Just registered free trial
                17: 'active',    // Free trial
                18: 'expired',   // Waiting on forms free trial
                19: 'prospect'   // Prospect
            };
            return map[$scope.company.status] === clientStatus;
        };

        $scope.accountStatusButtonAction = function() {
            if ($scope.company.status === $scope.Status.ON_BREAK ||
                $scope.company.status === $scope.Status.HOLIDAY ||
                $scope.company.status === $scope.Status.NOT_ACTIVE ||
                $scope.company.status === $scope.Status.REMOVED) {
                $scope.goto('company-profile');
                return;
            }

            var map = {
                1:  'company-profile',  // Just registered
                2:  'company-profile',  // Client
                3:  'company-profile',  // Not active
                5:  'company-profile',  // Removed
                6:  'billing',          // Not paid
                7:  'company-profile',  // Holiday
                8:  'company-profile',  // Break
                9:  'full-membership',  // Waiting on forms client
                10: 'billing',          // Collecting agency
                11: 'billing',          // Bankrupt
                12: 'company-profile',  // Wait for confirmation free trial
                13: 'company-profile',  // Queue list free trial
                14: 'full-membership',  // Block free trial
                16: 'company-profile',  // Just registered free trial
                17: 'company-profile',  // Free trial
                18: 'full-membership',  // Waiting on forms free trial
                19: 'company-profile'   // Prospect
            };
            $scope.goto(map[$scope.company.status]);
        };
    }]);
